import React from 'react';
import {SignIn} from '@/features/Authentication/routes/SignIn';
import {Unauthorized} from '@/features/Authentication/routes/Unauthorized';
import {Navigate, useLocation} from 'react-router-dom';
import {SetPassword} from "@/features/Authentication/routes/SetPassword";

import {saveReturnPath, isSafeReturnPath} from '@/utils/authRedirect';

const RedirectToSignIn = () => {
    const location = useLocation();
    const returnPath = `${location.pathname}${location.search}`;

    saveReturnPath(location.pathname, location.search);

    const signInTo = isSafeReturnPath(returnPath)
        ? `/signin?returnUrl=${encodeURIComponent(returnPath)}`
        : '/signin';

    return <Navigate to={signInTo} state={{ from: location }} replace />;
};

export const publicRoutes = [
    {
        path: '/signin',
        element: <SignIn/>,
    },
    {
        path: '/set-password',
        element: <SetPassword/>,
    },
    {
        path: '/unauthorized',
        element: <Unauthorized/>,
    },
    {path: '*', element: <RedirectToSignIn />},
];
